<template>
  <el-card>
    <div class="clearfix" style="vertical-align: middle" slot="header">
      <el-button @click="goBack()" class="pull-left">
          <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
        >&nbsp;
        <el-tag size="medium" v-if="clientDetail.DciProduct">{{ clientDetail.DciProduct.SN }}</el-tag>&nbsp;
        <el-tag size="medium" v-if="clientDetail.Name">{{ clientDetail.Name }}</el-tag>
      <!-- <el-button size="small" class="pull-right" @click="showChart"><i class="ion-arrow-graph-up-right"></i> 设备数据趋势图</el-button> -->
    </div>
    <el-tabs type="card" v-model="categoryActive" @tab-click="changeTab">
      <el-tab-pane
        v-for="(category, index) in categories"
        :key="index"
        :name="category.ID.toString()"
        v-loading="loading"
      >
        <span slot="label"
          >{{ category.Name }}
          <i
            class="el-icon-refresh"
            v-if="categoryActive === category.ID.toString()"
            title="刷新"
          ></i
        ></span>
        <div style="overflow-x: auto">
          <table class="mar-top message-table" v-if="messageList.length > 0">
            <thead>
              <tr>
                <th class="text-center text-nowrap" style="width: 10px">#</th>
                <th
                  class="text-center text-nowrap"
                  v-for="(stream, index) in category.Streams"
                  :key="index"
                  v-if="stream.Exhibited"
                >
                  <span>{{ stream.Name }}</span>
                  <span v-if="stream.Keypath.indexOf('*') > -1">…</span>
                </th>
                <th class="text-center text-nowrap">更新时间</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(message, index) in messageList"
                :key="index"
                @click="showMessage(message)"
              >
                <!-- 按住alt点击数据index，即触发了删除数据事件 -->
                <td
                  class="pad-hor text-center text-nowrap"
                  @click.alt.stop="deleteMessage(message)"
                >
                  {{ index + 1 }}
                </td>
                <td
                  class="pad-hor text-center text-nowrap"
                  v-for="(stream, index) in category.Streams"
                  :key="index"
                  v-if="stream.Exhibited"
                >
                  <span v-if="stream.Template !== ''">{{
                    compileTemplate(
                      stream,
                      analyseKeypath(stream.Keypath, message.Payload)
                    )
                  }}</span>
                  <span
                    v-else-if="stream.Options && stream.Options.length > 0"
                    >{{ getOptionValue(stream, message.Payload) }}</span
                  >
                  <span v-else>{{
                    analyseKeypath(stream.Keypath, message.Payload)
                  }}</span>
                </td>
                <td class="pad-hor text-center text-nowrap">
                  <span :title="message.UpdatedAt">{{
                    $sys.dateFormat(message.UpdatedAt, "Y-m-d H:i:s")
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="pad-hor text-muted">设备在该数据集下没有数据</div>
        </div>
      </el-tab-pane>
      <div class="clearfix mar-top">
        <el-pagination
          class="pull-right"
          @current-change="changePage"
          layout="total, prev, pager, next"
          :total="totalItem"
          :current-page="currentPage"
          :page-size="15"
        >
        </el-pagination>
      </div>
    </el-tabs>
    <el-dialog
      title="数据详情"
      :visible="messageVisible"
      :close-on-click-modal="false"
      @close="messageVisible = false"
    >
      <div v-if="showOriginal || messageDetail.length === 0">
        {{ messageOriginal }}
      </div>
      <div v-else>
        <el-row
          v-for="(msg, index) in messageDetail"
          :key="index"
          class="pad-ver"
          style="
            margin-left: 25px;
            margin-right: 25px;
            border-bottom: 1px solid #e9e9e9;
            margin-bottom: 10px;
          "
        >
          <el-col :span="10">
            <span>{{ msg.Name }}</span>
            <sup v-if="msg.Sup" class="text-muted">[{{ msg.Sup }}]</sup>
          </el-col>
          <el-col :span="14" class="pad-lft">{{ msg.Value }}</el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="messageDetail.length > 0"
          @click="showOriginal = !showOriginal"
        >
          <span>{{ showOriginal ? "显示解析后的数据" : "显示原始数据" }}</span>
        </el-button>
        <el-button type="primary" @click="messageVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      class="stream-chart"
      title="数据流图表"
      v-model="chartVisible"
      :close-on-click-modal="false"
      size="large"
      top="5%"
    >
      <div class="clearfix">
        <el-select
          class="pull-right"
          v-model="streamSelected"
          placeholder="请选择需要绘制的数据流"
          @change="getChartData"
        >
          <el-option
            v-for="stream in floatStream"
            :value="stream.ID"
            :label="stream.Name"
            :key="stream.ID"
          ></el-option>
        </el-select>
        <div class="pull-right mar-hor">
          <el-button
            type="primary"
            size="small"
            @click="changeChartPage(1)"
            :disabled="chartPage === chartLastPage"
            ><i class="icon ion-chevron-left"></i
            >&nbsp;查询更老的数据</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="changeChartPage(-1)"
            :disabled="chartPage === 1"
            >查询更新的数据&nbsp;<i class="icon ion-chevron-right"></i
          ></el-button>
        </div>
        <el-select
          class="pull-right"
          v-model="chartMessageNumber"
          placeholder="请选择图表数据数量"
          @change="changeMessageNumber"
        >
          <el-option :value="15" label="每页15条数据"></el-option>
          <el-option :value="30" label="每页30条数据"></el-option>
          <el-option :value="60" label="每页60条数据"></el-option>
        </el-select>
      </div>
      <div id="streamChart"></div>
    </el-dialog>
  </el-card>
</template>
<script>
import { mapState } from "vuex";
// import G2 from 'g2';
import {
  find as _find,
  template as _template,
  forOwn as _forOwn,
  map as _map,
  uniq as _uniq,
  get as _get,
} from "lodash";

export default {
  data() {
    return {
      clientId: this.$route.params.id,
      clientDetail: {},
      messageList: [],
      categoryActive: "",
      categorySelected: "",
      currentPage: 1,
      totalItem: 1,
      // 存放数据流模板函数
      streamTemplates: {},
      messageVisible: false,
      messageDetail: [],
      messageOriginal: "",
      // 是否显示原始数据
      showOriginal: false,
      isBack: false,
      messageSelected: "",
      loading: false,
      streamSelected: "",
      // 数据流图表dialog
      chartVisible: false,
      chartData: [],
      chartMessageList: [],
      chartPage: 1,
      chartLastPage: 1,
      chartMessageNumber: 15,
      categories: [],
    };
  },
  computed: {
    floatStream() {
      return this.categories.length > 0
        ? _find(this.categories, { ID: +this.categoryActive }).Streams.filter(
            (stream) => stream.exhibited && stream.type === "float"
          )
        : [];
    },
  },
  watch: {
    categories() {
      if (this.categories.length > 0) {
        this.categoryActive = this.categories[0].ID.toString();
        this.categorySelected = _find(this.categories, {
          ID: +this.categoryActive,
        }).Taxo;
        this.getMessageList();
        // this.getChartMessageList();
      }
    },
  },
  mounted() {
    this.getCategories();
    this.getClientDetail();
    if (this.categories.length > 0) {
      this.categoryActive = this.categories[0].ID.toString();
      this.categorySelected = _find(this.categories, {
        ID: +this.categoryActive,
      }).Taxo;
      this.getMessageList();
      // this.getChartMessageList();
    }
  },
  beforeDestroy() {
    // 若进入的页面不是设备数据index页面，则将store中保存的查询信息清空
    if (!this.isBack) {
      this.$store.commit("APPLICATION_SET_MSG_CLIENT_QUERY", {
        q: "",
        group_id: null,
        tags: "",
        online: "all",
      });
      this.$store.commit("APPLICATION_SET_MSG_CLIENT_PAGE", { currentPage: 1 });
    }
  },
  methods: {
    analyseKeypath(keypath, payload) {
      let path = keypath.replace(/\.\*/g, "[0]");
      path = path.replace(/\.\d+/g, "[$&]").replace(/\[\./g, "[");

      let data = _get(payload, path, "");

      if (path === "qn") {
        data = this.$sys.dateFormat(data / 1000, "Y-m-d H:i:s");
      }

      return data; //_get(payload, path, "");
    },
    getCategories() {
      this.$axios.get("category/list", { params: { with: ["Streams"] } }).then(
        (response) => {
          this.categories = response.data.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // 获取设备信息
    getClientDetail() {
      this.$axios.get(`dci/station/${this.clientId}`).then(
        (response) => {
          this.clientDetail = response.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // 获取设备数据列表
    getMessageList() {
      this.loading = true;
      this.$axios
        .get("/dci/station/message", {
          params: {
            where: {
              DciStationID: this.clientId,
              Taxo: this.categorySelected,
            },
            page: this.currentPage,
            order: ["-created_at"],
          },
        })
        .then(
          (response) => {
            this.loading = false;
            this.messageList = response.data.data;
            this.totalItem = response.data.total;
          },
          (response) => {
            this.loading = false;
            this.$sys.alarmResponse(response);
          }
        );
    },
    // 翻页
    changePage(page) {
      this.currentPage = page;
      this.getMessageList();
    },
    // 切换数据集tab页
    changeTab() {
      this.categorySelected = _find(this.categories, {
        ID: +this.categoryActive,
      }).Taxo;
      // changePage会监测页码的变化，自动调用dispatch
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getMessageList();
      }
    },
    // 按照数据流template编译数据，并存储在state里
    compileTemplate(stream, value) {
      if (typeof value !== "boolean" && !value) {
        return "";
      }
      if (!this.streamTemplates[this.categorySelected]) {
        this.$set(this.streamTemplates, this.categorySelected, {});
        this.$set(
          this.streamTemplates[this.categorySelected],
          stream.keypath,
          _template(stream.template)
        );
      } else if (!this.streamTemplates[this.categorySelected][stream.keypath]) {
        this.$set(
          this.streamTemplates[this.categorySelected],
          stream.keypath,
          _template(stream.template)
        );
      }
      try {
        return this.streamTemplates[this.categorySelected][stream.keypath]({
          value,
        });
      } catch (e) {
        return "#error#";
      }
    },
    // 获取数据流type为bool或enum类型的message的值
    getOptionValue(stream, payload) {
      const key = this.analyseKeypath(stream.keypath, payload);
      const optionValue = _find(stream.options, { key });
      if (optionValue) {
        return optionValue.value;
      }
      return key;
    },
    // 显示数据详情dialog
    showMessage(message) {
      this.showOriginal = false;
      this.messageVisible = true;
      this.messageDetail = [];
      this.messageOriginal = "";
      // 若payload不是object格式,直接输出
      this.messageOriginal = message.Payload;
      if (typeof message.Payload === "object") {
        // 遍历message.payload将其转化为[{key,value}]数组
        let singleMessageDetail = [];
        _forOwn(message.Payload, (value, key) => {
          if (key !== "$taxo") {
            singleMessageDetail = this.analyseMessage(
              singleMessageDetail,
              {},
              value,
              key
            );
          }
        });
        const streams = _find(this.categories, {
          ID: +this.categoryActive,
        }).Streams;
        streams.forEach((stream) => {
          // 遍历数据流，将message.payload根据对应数据流的name转换成 { name: xxx, sup: xxx, value: xxx }形式
          if (stream.Exhibited) {
            const analysedMsg = this.analyseKeypathOpposite(
              stream.Keypath,
              singleMessageDetail,
              stream.Name
            );
            // singleMessageDetail = analysedMsg.messageDetail;
            this.messageDetail = this.messageDetail.concat(
              analysedMsg.messageDetail
            );
            // 根据各message值对应的数据流，根据其template或options翻译
            if (stream.Template !== "") {
              analysedMsg.messageDone.forEach((msg) => {
                msg.value = this.compileTemplate(stream, msg.value);
              });
            } else if (stream.Options && stream.Options.length > 0) {
              analysedMsg.messageDone.forEach((msg) => {
                const optionValue = _find(stream.Options, { key: msg.value });
                if (optionValue) {
                  msg.value = optionValue.value;
                } else {
                  msg.value = msg.value;
                }
              });
            }
            this.messageDetail = this.messageDetail.concat(
              analysedMsg.messageDone
            );
          }
        });
        let messageRemained = [];
        singleMessageDetail.forEach((item) => {
          let detail = {};
          if (item.key.indexOf(".") == -1) {
            detail.Name = item.key;
            detail.Sup = "";
          } else {
            detail.Name = item.key
              .replace(/\.\d+\./g, "[$&].")
              .replace(/\[\./g, "[")
              .replace(/\.\]/g, "]");
          }

          detail.Value = item.value;
          messageRemained.push(detail);
        });

        this.messageDetail = this.messageDetail.concat(messageRemained);
      }
    },
    //解析json，存放成key，value数组
    analyseMessage(obj, item, value, key) {
      if (key != "qn") {
        if (typeof value === "object") {
          let keystr = key;
          _forOwn(value, (subvalue, subkey) => {
            keystr = key + "." + subkey;
            obj = this.analyseMessage(obj, {}, subvalue, keystr);
          });
        } else {
          item.key = key;
          item.value = value;
          obj.push(item);
        }
      }
      return obj;
    },
    //根据数据流配置信息和存放的key，value数组，重组成列表
    analyseKeypathOpposite(keypath, singleMessageDetail, name) {
      let messageDetail = [];
      let messageDone = [];
      let analysedMsg = {};

      for (let i in singleMessageDetail) {
        let item = singleMessageDetail[i];
        let pathname = item.key.replace(/\.\d+\./g, ".*.");
        var reg = /\.\d+\./;
        let num = "";
        if (pathname != item.key) {
          num = (item.key.match(reg) + "").replace(/\./g, "");
          if (num == null) {
            num = "";
          }
        }
        if (keypath === pathname) {
          let detail = {};
          detail.Name = name;
          detail.Sup = num;
          detail.Value = item.value;
          messageDetail.push(detail);

          singleMessageDetail.splice(i, 1);
          if (num == "") {
            break;
          }
        }
      }

      //TODO:messageDone未处理
      analysedMsg = { messageDetail, messageDone };
      return analysedMsg;
    },
    // 返回上一页，并且不清空client查询
    goBack() {
      this.isBack = true;
      this.$router.go(-1);
    },
    // 删除当前数据
    deleteMessage(message) {
      this.messageSelected = message.ID;
      this.$confirm("请确认是否将此数据删除?", "删除设备数据", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .delete(`dci/station/message/${this.messageSelected}`)
            .then(
              () => {
                this.getMessageList();
                this.$message({
                  type: "success",
                  message: "数据集删除成功!",
                });
              },
              (response) => {
                this.$sys.alarmResponse(response);
              }
            );
        })
        .catch(() => {});
    },
    // 获取图表的数据
    getChartMessageList(draw = false) {
      this.$axios
        .get("dci/station/message", {
          params: {
            where: {
              DciStationID: this.clientId,
              Taxo: this.categorySelected,
            },
            page: this.chartPage,
            size: this.chartMessageNumber,
          },
        })
        .then(
          (response) => {
            this.chartMessageList = response.data.data;
            this.chartLastPage = response.data.last_page;
            if (draw) {
              this.getChartData();
            }
          },
          (response) => {
            this.$sys.alarmResponse(response);
          }
        );
    },
    // 显示数据流图表
    showChart() {
      this.chartVisible = true;
      if (this.streamSelected === "") {
        this.streamSelected = this.floatStream[0].id;
      }
      setTimeout(this.getChartData, 0);
    },
    getChartData() {
      const stream = _find(this.floatStream, { id: this.streamSelected });
      const streamKeys = stream.keypath.split(".");
      // 获取数据流数据
      const result = [];
      this.chartMessageList.forEach((message) => {
        let analysingMessage = {};
        const analysedMessage = {};
        _forOwn(message.Payload, (value, key) => {
          if (key === streamKeys[0]) {
            analysingMessage = { ...this.analyseMessage([], {}, value, key) };
          }
        });
        _forOwn(analysingMessage, (value, key) => {
          if (key.replace(/\d/g, "*") === stream.keypath) {
            analysedMessage[key] = value;
          }
        });
        if (Object.keys(analysedMessage).length === 0) {
          analysedMessage[stream.keypath] = null;
        }
        result.push(analysedMessage);
      });
      // 数据流需要绘制的line
      let keys = [];
      result.forEach((obj) => {
        keys.push(...Object.keys(obj));
      });
      keys = _uniq(keys);
      if (keys.length > 1) {
        keys = keys.filter((key) => key !== stream.keypath);
      }
      // 生成图表数据
      this.chartData = [];
      this.chartMessageList.forEach((message, order) => {
        keys.forEach((key, index) => {
          this.chartData.push({
            date: message.created_at,
            name: keys.length > 1 ? `${stream.name}${index + 1}` : stream.name,
            count: result[order][key] !== undefined ? result[order][key] : null,
          });
        });
      });
      this.drawChart();
    },
    // 绘制图表
    drawChart() {
      if (this.chart) {
        this.chart.changeData(this.chartData);
      } else {
        // this.chart = new G2.Chart({
        //   id: 'streamChart',
        //   forceFit: true,
        //   height: 550,
        //   plotCfg: {
        //     margin: [25, 120, 70, 75],
        //   },
        // });
        this.chart = {};
        this.chart.source(this.chartData, {
          date: {
            type: "time",
            alias: "时间",
            mask: "yyyy-mm-dd hh:mm:ss",
          },
          name: {
            alias: "数据流",
            type: "cat",
          },
        });
        this.chart.axis("count", {
          title: null,
        });
        this.chart.axis("date", {
          title: {
            fontWeight: "bold",
            fill: "#666",
          },
          labels: {
            custom: true,
            renderer: (
              value
            ) => `<div class="text-center" style="font-size: 12px; width: 62px;">
            <div>${value.split(" ")[0]}</div><div>${
              value.split(" ")[1]
            }</div></div>`,
          },
        });
        this.chart.line().position("date*count").color("name").size(2);
        this.chart.point().position("date*count").shape("circle").color("name");
        this.chart.tooltip({
          crosshairs: true,
          map: {
            title: "date",
          },
        });
        this.chart.render();
      }
    },
    changeChartPage(change) {
      if (change === 1) {
        this.chartPage++;
      } else if (change === -1) {
        this.chartPage--;
      }
      this.getChartMessageList(true);
    },
    changeMessageNumber() {
      this.chartPage = 1;
      this.getChartMessageList(true);
    },
  },
};
</script>
<style>
.message-table {
  min-width: 100%;
  border: 1px solid #e9e9e9;
  border-collapse: collapse;
}
.message-table thead th,
.message-table tbody td {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #e9e9e9;
}
.message-table thead th {
  padding: 0 18px;
}
.message-table tbody tr:hover {
  background-color: #eef2f6;
}
.height-30 {
  height: 30px;
  line-height: 30px !important;
}
.stream-chart .el-dialog__body {
  padding-top: 10px;
}
</style>
